import { createContext, useContext } from 'react';
import { IEventUniqueNameProviderProps } from '../types/IEventUniqueNameProviderProps';

const EventDetailsContext = createContext(null);

export const EventDetailsProvider: React.FC<IEventUniqueNameProviderProps> = ({
    eventUniqueName,
    isEventWhiteLabel,
    whitelabelPath,
    children,
}) => (
    <EventDetailsContext.Provider value={{ eventUniqueName, isEventWhiteLabel, whitelabelPath }}>
        {children}
    </EventDetailsContext.Provider>
);

export const useEventDetailsContext = () => useContext(EventDetailsContext);
